
import {metagApi} from "@/axios";

// 查询项目共享人列表
export function listProjectSharerMetag(projectId) {
    return metagApi({
        url: '/project/share/list/'+projectId,
        method: 'get',
    })
}
// 删除项目共享人
export function delProjectSharerMetag(data) {
    return metagApi({
        url: '/project/share/delete',
        method: 'post',
        data:data
    })
}
export function addProjectSharerMetag(data){
    return metagApi({
        url:'/project/share/add',
        method:'post',
        data:data
    })
}
